import React from "react";

export const AGREEMENT_VERSION = "v1.0";

const S = ({ n, title, children }) => (
    <section className="mt-6">
        <h3 className="font-heading font-bold text-base">{n}. {title}</h3>
        <div className="text-sm text-yc-ink/80 leading-relaxed mt-2 space-y-2">{children}</div>
    </section>
);

const UL = ({ items }) => (
    <ul className="list-disc pl-5 space-y-1">
        {items.map((x, i) => <li key={i}>{x}</li>)}
    </ul>
);

export const CreatorAgreementText = () => (
    <div>
        <h2 className="font-heading text-2xl font-black tracking-tight">Creator Agreement</h2>
        <p className="text-sm text-yc-ink/70 mt-2">
            This Agreement is made between <strong>Nova Media Group LTD</strong> (trading as Curated Chaos) and the Content Creator (&ldquo;Creator&rdquo;).
        </p>

        <S n={1} title="Scope of Work">
            <p>The Creator agrees to provide content creation services including (but not limited to):</p>
            <UL items={["Filming short-form video content", "On-camera participation (if required)", "Editing, transitions, music", "Supporting brand storytelling aligned with campaign briefs"]} />
            <p>All work will be assigned per project, with clear deliverables outlined prior to execution.</p>
        </S>

        <S n={2} title="Curated Chaos Programme (Mentorship Clause)">
            <p>As part of the Curated Chaos initiative:</p>
            <UL items={["Junior or trainee creators may accompany lead creators on shoots", "This is for mentorship and development purposes", "All content captured (by any creator present) remains the property of Nova Media Group Ltd", "Lead creators are expected to support and guide junior creators professionally"]} />
        </S>

        <S n={3} title="Intellectual Property (IP)">
            <UL items={[
                "All content created under this agreement is 100% owned by Nova Media Group Ltd (the agreement between us, you and the brand)",
                "Curated Chaos retains full rights to use, edit, distribute, publish, and commercially exploit all content, and to provide content to clients for commercial use",
                "Curated Chaos is a registered trademark. Creators may not use the Curated Chaos name, branding, or associated assets for personal or commercial gain without prior written consent. Any misuse of the brand, logo, or associated intellectual property may result in legal action",
                "Creators may use content for portfolio purposes only",
            ]} />
        </S>

        <S n={4} title="Non-Compete & Non-Circumvention">
            <p>Creators may not:</p>
            <UL items={["Work directly with Curated Chaos clients introduced via this programme", "Circumvent Curated Chaos to secure work independently"]} />
            <p>This applies during the project and for 9 months after completion. Breach of this clause may result in legal action.</p>
        </S>

        <S n={5} title="Payment Terms">
            <UL items={[
                "Payment is agreed via platform",
                "Fees are inclusive of: creator time, equipment usage, and editing",
                "Creators must not invoice clients directly",
                "Payment timelines will be confirmed prior to project commencement",
            ]} />
        </S>

        <S n={6} title="Internal Events (Discount Clause)">
            <p>For Curated Chaos-owned events:</p>
            <UL items={["Creators agree to a 25% discounted rate from their standard fee", "This supports internal growth, brand building, and long-term collaboration opportunities"]} />
        </S>

        <S n={7} title="Professional Conduct & Code of Behaviour">
            <p>Creators are expected to uphold the highest level of professionalism at all times.</p>
            <p><strong>Creators must:</strong></p>
            <UL items={["Represent Curated Chaos professionally in all environments", "Be punctual, presentable, and prepared", "Respect clients, venues, artists, and team members"]} />
            <p><strong>Creators must NOT:</strong></p>
            <UL items={[
                "Request autographs, photos, or personal interactions from artists, talent, or individuals of significant public or commercial value",
                "Accept gifts, including (but not limited to) food, drink, clothing, or any items from clients, venues, or associated parties",
                "Engage in behaviour that may damage the reputation of Curated Chaos or its clients",
            ]} />
            <p>All interactions must remain strictly professional and work-focused. Failure to adhere to this code may result in immediate removal from the programme.</p>
        </S>

        <S n={8} title="Content Standards">
            <p>All content must:</p>
            <UL items={["Align with brand guidelines and campaign strategy", "Be authentic, engaging, and audience-focused", "Meet quality standards set by Curated Chaos"]} />
        </S>

        <S n={9} title="Force Majeure">
            <p>Nova Media Group Ltd is not liable for:</p>
            <UL items={["Cancelled shoots or events", "Travel or accommodation costs", "Loss of income"]} />
            <p>Where disruption occurs due to circumstances beyond reasonable control.</p>
        </S>

        <S n={10} title="Posting & Client Content Approval">
            <p>Creators must not post, share, or distribute any content (including behind-the-scenes footage) on personal or business platforms until:</p>
            <UL items={["The project has been completed", "Content has been approved by Curated Chaos", "Explicit permission has been granted by the client"]} />
            <p>Some projects may be subject to Non-Disclosure Agreements (NDAs). It is the Creator&apos;s responsibility to confirm whether posting is permitted and adhere strictly to any NDA or confidentiality requirements.</p>
            <p>Failure to comply may result in immediate removal from the programme and potential legal action depending on the severity of the breach.</p>
        </S>

        <S n={11} title="Confidentiality">
            <p>Creators must not disclose:</p>
            <UL items={["Client information", "Campaign strategies", "Internal processes or operations"]} />
            <p>This obligation remains in effect after termination of this agreement.</p>
        </S>

        <S n={12} title="Termination">
            <p>Nova Media Group Ltd reserves the right to:</p>
            <UL items={["Terminate this agreement at any time", "Remove creators from the programme without notice if standards are not met"]} />
        </S>

        <S n={13} title="Agreement">
            <p>By accepting this agreement during onboarding, both parties agree to the terms outlined above.</p>
        </S>
    </div>
);
